// Copyright (c) 2017 Comsearch, Inc., All rights reserved

import { useEffect } from 'react'
import { node } from 'prop-types'
import { useDispatch } from 'react-redux'
import fetchAndAddApplicationSettings from 'redux/modules/applicationSettings/thunks/fetchAndAddApplicationSettings'
import { authorizeNewSession } from 'redux/modules/user'
import { useBooleanToggle } from 'hooks'

// This is a HOC which wraps the application's router.
// So when the UI loads up, this dude mounts first
// and handles authorization of the session

const AuthWrapper = ({ children }) => {
  const dispatch = useDispatch()

  const [authFetched, toggleAuthFetched] = useBooleanToggle(false)

  useEffect(() => {
    (async () => {
      // TODO - add handling if authorizeNewSession fails for some reason? currently just throws to React.
      await dispatch(authorizeNewSession())
      await dispatch(fetchAndAddApplicationSettings())
      toggleAuthFetched()
    })()
  }, [])

  return (
    authFetched &&
    children
  )
}

AuthWrapper.propTypes = {
  children: node.isRequired,
}

export default AuthWrapper
